import { Provider } from "@angular/core";
import { provideDataLoad } from "@tylertech/data-load-module";
import { PurchaseOrderApprovalActionHandler, RequisitionApprovalActionHandler } from "./aggregateActionHandlers";
import { DepartmentLookupService, EPurchasingService, LegacyRequisitionService, ModuleControlService, PurchaseOrderLookupService, PurchaseOrderService, PurchasingChartService, PurchasingDialogsService, ReceiveGoodsService, ReqAndPoLookupService, RequestedByLookupService, RequisitionApprovalService, RequisitionLookupService, RequisitionSearchService, RequisitionService, } from "./services";

export function providePurchasing(): Array<Provider>
{
    return [
        provideDataLoad(),
        DepartmentLookupService,
        EPurchasingService,
        LegacyRequisitionService,
        ModuleControlService,
        PurchaseOrderLookupService,
        PurchaseOrderService,
        PurchasingChartService,
        PurchasingDialogsService,
        ReceiveGoodsService,
        ReqAndPoLookupService,
        RequestedByLookupService,
        RequisitionApprovalService,
        RequisitionLookupService,
        RequisitionSearchService,
        RequisitionService,
        PurchaseOrderApprovalActionHandler,
        RequisitionApprovalActionHandler,
    ];
}
